var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_2502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 0C7.87852 0 6.75 1.12852 6.75 2.53125C6.75 6.63398 9.21797 8.79609 10.8738 10.241L10.9898 10.3465C12.709 11.8441 13.5 12.6457 13.5 14.3438C13.5 15.7465 14.6285 16.875 16.0312 16.875C17.434 16.875 18.5625 15.7465 18.5625 14.3438C18.5625 10.241 16.0945 8.07891 14.4387 6.63398L14.3227 6.52852C12.6035 5.03086 11.8125 4.2293 11.8125 2.53125C11.8125 1.12852 10.684 0 9.28125 0ZM3.375 20.25C1.5082 20.25 0 21.7582 0 23.625V43.875C0 49.4648 4.53516 54 10.125 54H30.375C35.9648 54 40.5 49.4648 40.5 43.875H42.1875C48.716 43.875 54 38.591 54 32.0625C54 25.534 48.716 20.25 42.1875 20.25H37.125H3.375ZM40.5 27H42.1875C44.9824 27 47.25 29.2676 47.25 32.0625C47.25 34.8574 44.9824 37.125 42.1875 37.125H40.5V27ZM23.625 2.53125C23.625 1.12852 22.4965 0 21.0938 0C19.691 0 18.5625 1.12852 18.5625 2.53125C18.5625 6.63398 21.0305 8.79609 22.6863 10.241L22.8023 10.3465C24.5215 11.8441 25.3125 12.6457 25.3125 14.3438C25.3125 15.7465 26.441 16.875 27.8438 16.875C29.2465 16.875 30.375 15.7465 30.375 14.3438C30.375 10.241 27.907 8.07891 26.2512 6.63398L26.1352 6.52852C24.416 5.03086 23.625 4.2293 23.625 2.53125Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_2502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMug);
export default __webpack_public_path__ + "static/media/mug.04688f6eb96f55a1ea0267c963fac916.svg";
export { ForwardRef as ReactComponent };